module.exports = __webpack_public_path__ + "static/media/mexico.295a10ac.svg";